<template>

  <b-modal @hidden="onHidden" @show="onShow" no-close-on-backdrop no-close-on-esc size="xl"
           :id="id"
           hide-footer
           :title="'Alterar Ordem'">

    <t-form-list-ordained :primary-key-column="primaryKeyColumn"
                          :path-ordained="path"
                          :foreign-key-column-ordained="foreignKeyColumn"
                          :foreign-key="foreignKey"
                          :enable-change-order-up-down="enableChangeOrderUpDown"
    />
  </b-modal>

</template>
<script>


import tFormListOrdained from "@/components/template/form/list/t-form-list-ordained";

export default {
  name: 't-dialog-ordained',
  components: {tFormListOrdained},
  data() {
    return {
      id:"modal-ordained",
    }
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    primaryKeyColumn: {
      type: String,
      required: true,
    },
    foreignKeyColumn: {
      type: String,
      required: true,
    },
    foreignKey:{
      type: Number,
      default:0,
      required: false,/*Usado somente quando for diferente de onlaineId a chave estrangeira e por tanto em relação a um todo da lista*/
    },
    dialogId:{
      type:String,
      default:""
    },
    enableChangeOrderUpDown:Boolean,
  },
  mounted() {

    if(this.dialogId !== ''){
      this.id = this.dialogId
    }

  },

  methods: {
    onShow() {
      this.$emit('show')
    },
    onHidden() {
      this.$emit('hidden')
    },
  },
}
</script>
